<div class="form-container">
    <form class="form" [formGroup]="form">
        <div class="fields-container" *ngFor="let field of formConfig.fields;">
            <ng-container dynamicField [field]="field" [group]="form">
                <div class="span-container">
                    <span class="spanTitle fs_text bold">{{field.spanLabel}}</span>
                </div>
            </ng-container>
        </div>
    </form>
</div>